export * from './menu.reducer';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu/reducers/index.ts